<template>
  <div>
    <ProgressBar />
    <PageHeading :default-heading="pageHeader" />
    <form
      ref="igoForm"
      :action="pd_envConfig.toaURL"
      method="POST"
      @submit.prevent
    >
      <div
        class="pvd-container container-divider"
      >
        <h2
          v-if="rc_accountNumber"
          id="igoHeading"
          class="pvd-heading-L"
        >
          {{ `${pd_content.your_accountnumber} ${rc_accountNumber}` }}
        </h2>
        <p>
          {{ pd_content.account_onboard }}
        </p>
        <input
          ref="acctnum"
          type="hidden"
          name="acctnum"
          :value="queryParamAccountNum"
        >
        <input
          ref="regType"
          type="hidden"
          name="regType"
          value=""
        >
      </div>
      <NavigationComponent />
    </form>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import constants from '../mixins/constants';
import NavigationComponent from '../components/NavigationComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';
import 'url-search-params-polyfill';

export default {
  name: 'CustomerIGO',
  components: {
    NavigationComponent,
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      backButtonAttempt: false,
    };
  },
  computed: {
    pageHeader() {
      const pageHeader = this.newCustomer
        ? this.pd_content.customer_igo_page_header || constants.CUSTOMER_IGO_PAGE_HEADER : this.pd_content.final_page_header;

      if (pageHeader) {
        document.title = this.setTitle(pageHeader);
      }
      return pageHeader;
    },
    newCustomer() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.has('NEW_CUSTOMER') ? urlParams.get('NEW_CUSTOMER') === 'true' : false;
    },
    queryParamAccountNum() {
      let accountNumber = '';
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('ACCOUNT_NO')) {
        accountNumber = urlParams.get('ACCOUNT_NO');
      }
      return accountNumber;
    },
  },
  mounted() {
    this.track('customer-igo', 'pageview');
    this.configureFirstPageBackButton(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
  },
  methods: {
    openEIWindow() {
      this.track('ei_section_link', 'interaction');
      const url = this.pd_envConfig.eiURL;
      this.openWindow(url, 'documentwindow');
    },
  },
};

</script>

<style scoped>

</style>
